export const CONSULTATION_MODULES = {
  CLINIC_CONSULTATION: "clinic-consultation",
};
